import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'animate.css';
import "@/assets/style/index.scss"
import { setStorage, getStorage, removeStorage } from '@/utils'  

setStorage("APP_TITLE", "智能衣物柜管理系统")
createApp(App).use(store).use(router).use(ElementPlus, {
    locale: zhCn,
}).mount('#app')
/**
 * # 安装依赖
 * npm install element-ui animate.css axios echarts vuex vue-router js-cookie
 * npm install element-plus axios echarts vuex vue-router pinia animate.css nprogress
 * npm install element-plus --save  
 * npm install axios js-md5
 * npm install vue-cookies
 * npm install animate.css
 * 
 * npm config set registry https://registry.npmmirror.com
 * npm install echarts --save
 */
